import Hero from "../components/hero/Hero";
import Categories from "../components/categories/Categories";
import Partners from "../components/partners/Partners";
import Services from "../components/services/Services";
import Cover from "../components/cover/Cover";
import Cta from "../components/cta/Cta";
import Sucursales from "../components/sucursales/Sucursales";

const Home = () => {

  return(
    <>
      <Hero/>
      <Categories/>
      <Partners/>
      <Services/>
      <Cover/>
      <Cta/>
      <Sucursales/>
    </>
  )
}

export default Home;